import {DebounceSelectOptionProps} from "../../../components/UI/AntCustom/DebounceSelect";
import {
  TimezoneApiTimezoneListRequest, TimezoneApiTimezoneListResponse
} from "../../../proto/generated/api_entities_pb";
import {API} from "../../../API/API";
import {ITimezone} from "../../../store/reducers/userReducer/userReducerTypes";
import {DisplayTimezoneOffset} from "../textDisplayHelpers/DisplayTimezoneOffset";
import {store} from "../../../store/store";


export async function fetchTimezones(search: string): Promise<DebounceSelectOptionProps[]> {
  // Получаем таймзоны из store
  const state = store.getState();
  const timezones = state.timezone.timezones;

  // Если таймзоны уже загружены в store, используем их
  if (timezones && timezones.length > 0) {
    const searchLower = search.toLowerCase();
    return timezones
      .filter(tz => tz.name.toLowerCase().includes(searchLower))
      .map(tz => ({
        key: tz.id,
        label: tz.name,
        value: tz.id,
      }));
  }

  // Если таймзоны еще не загружены, делаем запрос (fallback)
  const req = new TimezoneApiTimezoneListRequest().setQuery(search);
  const res: TimezoneApiTimezoneListResponse = await API.getTimezoneList(req);

  return res.getTimezonesList().map(tz => {
    const tzName = tz.getName();
    const label = `${tzName} ${DisplayTimezoneOffset(tz.getOffset())}`;

    return {
      key: tz.getTimezoneid(),
      label: label,
      value: tz.getTimezoneid(),
    }
  })
}

export const getInitialTimezoneForSelect = (timezone: ITimezone): DebounceSelectOptionProps => {
  return {
    key: timezone.id,
    value: timezone.id,
    label: timezone.name,
  }
}